module.exports = __webpack_public_path__ + "img/stellenbosch-logo-icon.84ed0f92.png";